import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Activities } from "src/modules/activity-log/activity";
import RoundButton from "../../RoundButton";
import { ResponsiveCaption } from "../../ResponsiveCaption";
import { ReactComponent as CommandIcon } from "./command.svg";

export default function NoCommandsButton({
  isDarkMode,
  openCommandFlow,
  mode,
  activity,
  ...rest
}) {
  const { t } = useTranslation();
  let bg;
  if (
    mode === "audio" &&
    (activity === Activities.SLEEPING || activity === Activities.MOTION)
  ) {
    bg = "black8";
    if (isDarkMode) bg = "white20";
  } else {
    bg = "black20";
  }

  return (
    <Flex flexDirection="column" alignItems="center" {...rest}>
      <RoundButton
        bg={bg}
        iconSize="50%"
        size={["40px", "56px", "64px"]}
        icon={CommandIcon}
        iconFill={
          mode === "video" || activity === Activities.AWAKE || isDarkMode
            ? "white"
            : "black54"
        }
        onClick={openCommandFlow}
        mb="4px"
      />
      <ResponsiveCaption
        color={
          isDarkMode || mode === "video" || activity === Activities.AWAKE
            ? "white70"
            : "black54"
        }
      >
        {t("buttons.command")}
      </ResponsiveCaption>
    </Flex>
  );
}
